// @ts-check
import { defineConfig } from '../utils';

export function alerts() {
  return defineConfig({
    properties: {
      'Alertas.ActivarConFiltro': {
        defaultValue: false,
      },
      'Alertas.ActualizarAutomaticamente': {
        defaultValue: true,
      },
      'Alertas.TiempoActualizacionAutomatica': {
        defaultValue: 60,
      },
    },
  });
}
